module.exports = __webpack_public_path__ + "static/media/banner1.1c836604.jpg";